import { GetMedicalEquipmentApiParameter } from "@GeriMed/Services/MedicalEquipmentService";
import { MedicalEquipmentState } from "@GeriMed/Store/Data/MedicalEquipment/MedicalEquipmentState";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: MedicalEquipmentState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/MedicalEquipment/BeginLoadMedicalEquipment": (
        draft: Draft<MedicalEquipmentState>,
        action: { parameter: GetMedicalEquipmentApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/MedicalEquipment/CompleteLoadMedicalEquipment": (
        draft: Draft<MedicalEquipmentState>,
        action: { parameter: GetMedicalEquipmentApiParameter; collection: CustomerDisplayProductCollection },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => action.collection.productList,
        );
    },
    "Data/MedicalEquipment/Reset": () => {
        return initialState;
    },
};

const medicalEquipmentreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataMedicalEquipment = medicalEquipmentreducer;
